import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import HorizontalBarChartLoader from 'Pages/InsightsPage/Components/SkeletonLoaders/HorizontalBarChartLoader';
import { Status } from 'utils/customTypes';
import { BaseInsightPayload } from 'types/store/normalized/insights/InsightDataPayload';
import { SLICE_STATUS } from 'utils/constants';
import { OnDrillDown } from './chartBuilder';
import {
  INSIGHT_TO_CHART_COMPONENT_FACTORY_BUILDER,
  InsightCatalogue,
} from 'types/store/normalized/insights/InsightCatalogue';
import { InsightChartFactory } from 'types/store/normalized/insights/insightChartFactory';
import ChartError from './ChartError';

export interface InsightsChartProps {
  className?: string;
  chartData: BaseInsightPayload | undefined;
  chartDataStatus: Status | undefined;
  cardName: string;
  insightId: InsightCatalogue;
  onDrillDown: OnDrillDown;
}

const InsightsChartComponent = ({
  chartData,
  chartDataStatus,
  cardName,
  insightId,
  onDrillDown,
}: InsightsChartProps) => {
  let chartComponent: React.ReactElement | undefined;
  const { advancedRequestsCompletedStatus } = useFlags();

  try {
    const chartComponentFactoryBuilder =
      INSIGHT_TO_CHART_COMPONENT_FACTORY_BUILDER[insightId];
    if (chartComponentFactoryBuilder && chartData) {
      const chartComponentFactory: InsightChartFactory =
        chartComponentFactoryBuilder(chartData, {
          isCompletedStatusEnabled: Boolean(advancedRequestsCompletedStatus),
        });
      chartComponent = chartComponentFactory({
        name: cardName,
        onDrillDown,
      });
    }
  } catch (error) {
    return <ChartError />;
  }

  if (chartDataStatus === SLICE_STATUS.SUCCESS && chartComponent) {
    return chartComponent;
  } else {
    return <HorizontalBarChartLoader />;
  }
};

export default InsightsChartComponent;
